module.exports = __webpack_public_path__ + "media/images/dashboard/pencil-d8961c4c6e190e25d80dd5a761aff998.svg";